import { isMVA, getApplePayMerchantIdentifier, getParameterByName, getSession, setSession } from './index';
import { pageHeaders } from './pageHeaders';

const emptyFunc = () => null;
// MVA Bridge communication
export const postMessage = (msg = {}) => {
  try {
    const strMsg = JSON.stringify(msg);
    if (isMVA()) {
      console.log('isMVA is true');
    }
    if (window.vzFlags && window.vzFlags.logBridgeApi) {
      logBridgeApi(strMsg);
    }
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.mfAppInterface &&
      window.webkit.messageHandlers.mfAppInterface.postMessage
    ) {
      window.webkit.messageHandlers.mfAppInterface.postMessage(strMsg);
    }
    if (window.mfAppInterface && window.mfAppInterface.postMessage) {
      window.mfAppInterface.postMessage(strMsg);
    }
  } catch (err) {
    console.log('Error in app.js', err);
  }
};

export const logBridgeApi = (strMsg) => {
  console.log(strMsg);
};

// Set MVA Title
// DO NOT CALL DIRECTLY - If you are calling it directly you did not read this comment and will be receiving an email from me - Edwin
export const setTitle = (title = '') => {
  const msg = {
    actionType: 'setTitle',
    title,
  };
  postMessage(msg);
};

// Update MVA Cart Icon
// to do update button map

const ButtonValues = {
  PrimaryButton: {
    actionType: 'openPage',
    extraParameters: {
      browserUrl: `${window.location.origin}/sales/digital/cart.html`,
      clearSharedCart: true,
      fromNsaClick: 'true',
    },
    showNativeNavigation: true,
    pageType: 'retrieveCart',
    title: 'cartIcon',
    openInWebview: true,
    customUserAgent: 'MY_VZW_APP',
    hideWebNavigation: true,
    hideUrl: true,
    appContext: 'mobileFirstSS',
    openOauthWebView: false,
  },
};

// changing is_shared_cart value to false.
export const updateCartCount = (itemCount = 0, IS_SHARED_CART = false, ButtonMap = ButtonValues) => {
  setSession('gnCartCount', itemCount);
  setSession('uiupdatedacart', 'TRUE');
  const msg = {
    actionType: 'updateModule',
    ModuleMap: {
      SavedCart: {
        ButtonMap,
        IS_SHARED_CART,
        itemCount,
      },
    },
  };
  postMessage(msg);
};

// Open a pre-determined App page
export const goToNativePage = (pageType = '', extraParameters) => {
  const msg = {
    actionType: 'openPage',
    title: '',
    presentationStyle: 'push',
    tryToReplaceFirst: false,
    disableAction: false,
    pageType,
    extraParameters,
    appContext: 'mobileFirstSS',
  };
  postMessage(msg);
};

export const triggerApplePay = (merchantId = getApplePayMerchantIdentifier(), lineItems, callback) => {
  window.applePayCallback = callback;
  const msg = {
    actionType: 'applePayPayment',
    jsCallback: 'window.applePayCallback',
    lineItems,
    merchantId,
  };
  postMessage(msg);
};

// Get the current lat and long of customer
export const requestCurrentLatLong = (callback) => {
  window.currentLatLngCallback = callback || emptyFunc;
  const msg = {
    actionType: 'currentLatLng',
    jsCallback: 'window.currentLatLngCallback',
  };
  postMessage(msg);
  // response = { isSuccess:"Y", lat:"37.33233141", long:"-122.0312186" }
};

export const triggerIsApplePaySupported = (callback) => {
  window.isApplePaySupportedCallback = callback || emptyFunc;
  const msg = {
    actionType: 'isApplePaySupported',
    jsCallback: 'window.isApplePaySupportedCallback',
  };
  // {"isSuccess":"Y","isApplePaySupported":"Y/N"}
  postMessage(msg);
};

export const updateNavigation = (alwaysShowBackButton = true, title) => {
  //      title: 'Page title', Removed title it will reset title also
  const msg = {
    actionType: 'updateNavigation',
    navigationBar: {
      moleculeName: 'navigationBar',
      alwaysShowBackButton,
      title,
    },
  };
  postMessage(msg);
  // response = N/A
};

export const openBrowser = (browserUrl = 'https://verizonwireless.com', openInWebview = true) => {
  const msg = {
    actionType: 'openURL',
    pageType: 'openBrowser', // openBrowser is dummy value. It is just to pass null check in Bridge
    browserUrl,
    openInWebview,
  };
  postMessage(msg);
};

export const clearCaseBridge = () => {
  const msg = {
    actionType: 'openPage',
    pageType: 'retrieveCart',
    extraParameters: {
      clearSharedCart: true,
    },
  };
  updateCartCount(0, false);
  postMessage(msg);
};

export const triggerPayBillBridge = () => {
  const msg = {
    actionType: 'openPage',
    pageType: 'payBill',
  };
  postMessage(msg);
};

export const mvaGlobalNavUpdate = (pageName) => {
  // console.debug('mvaGlobalNavUpdate triggered');
  const mobileHeaderTitle = pageHeaders.filter((item) => pageName?.toLowerCase() === item?.page?.toLowerCase());
  if (mobileHeaderTitle?.length) {
    const { title, backIcon } = mobileHeaderTitle[0];
    const msg = {
      actionType: 'updateNavigation',
      navigationBar: {
        moleculeName: 'navigationBar',
        style: 'light',
        alwaysShowBackButton: backIcon,
        ...(title && { title }),
      },
    };

    if (backIcon) {
      msg.navigationBar.backButton = {
        image: 'nav_back',
        moleculeName: 'navigationImageButton',
        action: {
          title: 'back',
          tabBarIndex: 0,
          actionType: 'back',
          pageType: 'back',
        },
        accessibilityText: 'Back',
      };
    }

    // console.debug('mvaGlobalNavUpdate payload', msg);
    postMessage(msg);
  }
};

export const UpdateGlobalNavVariantsTypeA = (title) => {
  let alwaysShowBackButton = false;
  if (getParameterByName('showBackButton') === 'true') {
    alwaysShowBackButton = true;
  }
  const msg = {
    actionType: 'updateNavigation',
    navigationBar: {
      moleculeName: 'navigationBar',
      title,
      alwaysShowBackButton,
      additionalLeftButtons: [
        {
          moleculeName: 'navigationNotificationButton',
          action: {
            hideCloseButton: false,
            appContext: 'mobileFirstSS',
            openOauthWebView: false,
            analyticsData: {
              'vzwi.mvmapp.LinkName': 'global tab nav:alerts and messages',
            },
            checkCameraPermission: false,
            showNativeNavigation: false,
            disableAction: false,
            tryToReplaceFirst: false,
            openInWebview: true,
            actionType: 'openPage',
            analyticsReqData: {},
            hideUrl: false,
            presentationStyle: 'push',
            pageType: 'notificationCenterLanding',
            title: 'Alerts & Messages',
            selected: false,
            hideWebNavigation: false,
            isSelected: false,
          },
        },
      ],
      additionalRightButtons: [
        {
          moleculeName: 'navigationImageButton',
          image: 'nav_settings',
          action: {
            title: 'Settings',
            actionType: 'openPage',
            pageType: 'settingsLanding',
            analyticsData: {
              'vzwi.mvmapp.LinkName': 'global tab nav:settings',
            },
          },
        },
      ],
    },
  };
  postMessage(msg);
};

// Type B1,B2 and E. others cart, Wishlist are dynamic
export const updateNavigationForThreePointo = (title, alwaysShowBackButton) => {
  const msg = {
    actionType: 'updateNavigation',
    navigationBar: {
      moleculeName: 'navigationBar',
      title,
      alwaysShowBackButton,
    },
  };
  postMessage(msg);
};

// Type D
export const UpdateGlobalNavVariantsTypeD = (title) => {
  const msg = {
    actionType: 'updateNavigation',
    navigationBar: {
      moleculeName: 'navigationBar',
      alwaysShowBackButton: true,
      title,
      backButton: {
        moleculeName: 'navigationImageButton',
        image: 'nav_close',
        action: {
          title: 'Close',
          actionType: 'openPage',
          pageType: 'shopLanding', // openBrowser is dummy value. It is just to pass null check in Bridge
          analyticsData: {
            'vzwi.mvmapp.LinkName': 'close',
          },
        },
      },
    },
  };
  postMessage(msg);
};

export const tabBarHidden = () => {
  const msg = {
    actionType: 'updateTab',
    tab: {
      tabBarHidden: true,
    },
  };
  postMessage(msg);
};

export const fabIconHidden = () => {
  const msg = {
    actionType: 'updateChatFab',
    chatFab: {
      hideFabOverlay: true,
    },
  };
  postMessage(msg);
};

export const showFabIcon = (shouldExpandFab) => {
  const msg = {
    actionType: 'updateChatFab',
    chatFab: {
      hideFabOverlay: false,
      shouldExpandFab,
    },
  };
  postMessage(msg);
};
export const supportPayLoad = () => {
  let pageType = (window.vzwDL && window.vzwDL.page && window.vzwDL.page.pageName) || window.pageTitle || window.aemTitle;
  if (
    getParameterByName('preconfigure') === 'true' ||
    (window.location.href.indexOf('expressCheckout.html') > 0 && sessionStorage && getSession('preConfigureCart') === 'true')
  ) {
    pageType += 'PreConfigureCart';
  }
  const msg = {
    actionType: 'supportPayLoad',
    payLoad: {
      pageType,
    },
  };
  postMessage(msg);
};

export const updateTabBarIndex = () => {
  const msg = {
    actionType: 'updateTab',
    tab: {
      tabBarIndex: 2,
    },
  };
  postMessage(msg);
};

/*
 * Reload the feed cart from clear cart and submit order page
 */
export const reloadFeedCart = (callback) => {
  window.reloadFeedCart = callback || emptyFunc;
  // postMessage(msg);
};
